import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { get, put, del } from '../api/client.js';

const key = (from, to, target) => ['timesheet', from, to, target];

export function useTimesheet({ from, to, target }) {
  return useQuery({
    queryKey: key(from, to, target),
    enabled: !!from && !!to,
    queryFn: () => get(`/api/timesheet?from=${from}&to=${to}&user=${encodeURIComponent(target)}`),
    staleTime: 15_000,
  });
}

// One-shot fetch of a single entry by id (admin only). Used to re-open
// EntryEditModal from the audit log without hitting the timesheet endpoint.
export async function fetchEntry(id) {
  const body = await get(`/api/admin/entries/${id}`);
  return body.entry;
}

// Admin only — edit / delete a single clock entry with a required reason.
export function useUpdateEntry() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) => put(`/api/admin/entries/${id}`, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['timesheet'] }),
  });
}
export function useDeleteEntry() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }) => del(`/api/admin/entries/${id}?reason=${encodeURIComponent(reason)}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['timesheet'] }),
  });
}
